import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import './PricingCatalog.css';

export default function PricingDialog({ isOpen, onClose, canClose = true, children, tutorialAction }) {
  const { t, i18n } = useTranslation('pricing');
  const dialog = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!isOpen) return undefined;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current?.focus();
    const onKey = event => {
      if (event.key === 'Escape' && canClose) { event.preventDefault(); close.current?.(); }
      if (event.key !== 'Tab') return;
      const targets = Array.from(dialog.current?.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]') || [])
        .filter(el => el.getAttribute('tabindex') !== '-1' && !el.closest('[hidden]'));
      const first = targets[0], last = targets[targets.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) {
        event.preventDefault(); first.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKey);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [isOpen, canClose]);
  if (!isOpen) return null;
  return createPortal(<div className="jsq-pricing-overlay" onClick={event => {
    if (event.target === event.currentTarget && canClose) onClose?.();
  }}>
    <div className="jsq-pricing-dialog" ref={dialog} tabIndex={-1} role="dialog" aria-modal="true" aria-label={t('titles.eyebrow')} dir={i18n.dir()}>
      <div className="jsq-pricing-dialog-bar"><span>{t('titles.eyebrow')}</span><div>
        {tutorialAction && <button type="button" className="jsq-pricing-tutorial" onClick={tutorialAction}>{t('cta.showTutorial')}</button>}
        {canClose && <button type="button" className="jsq-pricing-close" onClick={onClose} aria-label={t('cta.close')}><i className="fa-solid fa-xmark" aria-hidden="true" /></button>}
      </div></div>
      {children}
    </div>
  </div>, document.body);
}
